import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { USER_TYPE, validity_date_v2_range_placeholder } from 'src/app/core/Constants/static';
import { UserDetails } from 'src/app/core/Models/interfaces/user-details';
import { UserService } from 'src/app/core/Services/user.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { ClientRuleService } from '../../services/client-rule.service';
import { ClientRuleConfigListing } from 'src/app/core/Models/interfaces/clientRuleConfigListing';
import { RuleConfigListing } from 'src/app/core/Models/interfaces/ruleconfig';

@Component({
  selector: 'app-client-rule-config-list',
  templateUrl: './client-rule-config-list.component.html',
  styleUrls: ['./client-rule-config-list.component.css']
})
export class ClientRuleConfigListComponent implements OnInit {

  @ViewChildren('focusedElement') focusedElement!: QueryList<any>;
  public providerList ?:any;
  public payerList ?:any;
  public ruleConfigList ?: any;
  feild_startDate = validity_date_v2_range_placeholder;
  showConfigurationEdit = false;
  showConfigurationDetails = false;
  systemConfigEdit:boolean=true
  selectedConfig!: RuleConfigListing;

  isAddPage = true;
  columnSort: any = {
    version: {
      sortType: 'ascending',
    },
    activeFrom: {
      sortType: 'ascending',
    }
  }
  fetchingInProgress = false;
  sortParams!: string;
  user?: UserDetails;
  page_limit = 10;
  page_no = 1;
  totalCount = 10;
  providerId: string='';
  payerId: string='';
  showNavigation = false;
  versionSort = '';
  filterationForm !: FormGroup;
  

  constructor(
    private toasterandLoader:ToasterService,
    private userService : UserService,
    private clientRuleService :ClientRuleService
  ) { }


  ngOnInit() {
    if (this.user?.userType === USER_TYPE.payer) {
      this.versionSort = 'payerRuleConfigurationVersion'
    } else if (this.user?.userType === USER_TYPE.provider) {
      this.versionSort = 'providerRuleConfigurationVersion'
    } else if (this.user?.userType === USER_TYPE.system) {
      this.versionSort = 'version'
    }

    this.filterationForm = new FormGroup({
      version: new FormControl(null),
      validity: new FormControl(null),
      inUse: new FormControl(null),
    });
  }

  sortColumn(colName: string) {
    for (const key in this.columnSort) {
      if (Object.prototype.hasOwnProperty.call(this.columnSort, key)) {
        if (key == colName) {
          this.columnSort[colName].clicked = true;
          this.columnSort[colName].sortType = (this.columnSort[colName].sortType == 'ascending') ? 'descending' : 'ascending';
          this.sortParams = (this.columnSort[colName].sortType == 'descending' ? '-' : '') + colName;
          this.applyFilter();
        }else{
          this.columnSort[key].sortType = 'ascending';
        }

      }
    }
  }
  checkPermission(perName:string):boolean{
    return this.userService.getPermissions(perName);
  }

  currentPageDetail(event: any) {

    if (event) {
      this.page_no = event.button_no;
      this.page_limit = event.item_per_page;
    }
    this.isScrollIntoViewNeeded();
    this.applyFilter();
  }

  isScrollIntoViewNeeded() {
    setTimeout(() => {
      this.focusedElement.last?.nativeElement.scrollIntoView();
    }, 100);
  }

  onApply() {
    this.page_no = 1;
    this.providerId = '';
    this.payerId = '';
    this.applyFilter();
  }
  onReset() {
    this.filterationForm.reset();
    this.providerId = '';
    this.payerId = '';
    this.sortParams = '';
    this.page_limit = 10;
    this.page_no = 1;
    this.totalCount = 1;
    this.showNavigation = false;
    this.applyFilter();
  }

  applyFilter() {
    this.toasterandLoader.isLoaderEnable(true);
    let validity = this.filterationForm.value.validity?this.filterationForm.value.validity:'';
    let valStart = validity.substring(0, validity.indexOf(' '));
    let parts: any[] = validity?.split(' ');
    let valEnd = parts?.pop();
    let validityStart = valStart?.split("/").reverse().join("-");
    let validityEndDate = valEnd?.split("/").reverse().join("-");

    let payLoad = {
      per_page: this.page_limit,
      page: this.page_no,
      isActive: this.filterationForm?.controls?.['inUse']?.value ? '1' : '',
      sort: this.sortParams,
      version: this.filterationForm?.controls?.['version']?.value || '',
      activeFrom: validityStart ? validityStart : '',
      expiredOn: validityEndDate ? validityEndDate : '',
    }

    // if (this.user?.userType === USER_TYPE.system && this.checkPermission('getclientRuleConfigList')) {
      this.clientRuleService.getSystemAllRules(payLoad,1).subscribe({ 
        next:(res) => {
          this.ruleConfigList = res?.data?.data
          this.totalCount = res?.data?.total
          this.fetchingInProgress = false;
          this.toasterandLoader.isLoaderEnable(false);
        },
        error: (err) => {
          this.fetchingInProgress = false;
          this.toasterandLoader.isLoaderEnable(false);
        }
      })
  }

  configurationAdd() {
    this.showConfigurationEdit = true;
    this.isAddPage = true;
  }

  manageEdit() {
    this.showConfigurationDetails = false;
    this.showConfigurationEdit = true;
    this.selectedConfig = this.selectedConfig;
    this.isAddPage = false;
  }
  public configurationDetails(item: ClientRuleConfigListing) {
    this.showConfigurationDetails = true;
    this.selectedConfig = item;

  }
  public configurationEdit(item: any) {
    this.showConfigurationEdit = true;
    this.selectedConfig = item;
    this.isAddPage = false;
  }

}




